import { useEffect, useRef } from 'react';
import QRCodeLib from 'qrcode';

export interface QRCodeProps {
  readonly value: string;
  readonly size?: number;
}

export function QRCode({ value, size = 256 }: QRCodeProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (canvasRef.current) {
      void QRCodeLib.toCanvas(canvasRef.current, value, {
        width: size,
        margin: 1,
      });
    }
  }, [value, size]);
  return <canvas ref={canvasRef} className="rounded-xl bg-white p-2" />;
}
